export const secondToMs = (seconds: number) => seconds * 1000
export const minuteToMs = (minutes: number) => secondToMs(minutes * 60)
